/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PatchArchiveStatusByWabaPhoneIdentifier$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  wabaPhoneIdentifier: string;
  archive: boolean;
}

export function patchArchiveStatusByWabaPhoneIdentifier(http: HttpClient, rootUrl: string, params: PatchArchiveStatusByWabaPhoneIdentifier$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patchArchiveStatusByWabaPhoneIdentifier.PATH, 'patch');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('wabaPhoneIdentifier', params.wabaPhoneIdentifier, {});
    rb.query('archive', params.archive, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

patchArchiveStatusByWabaPhoneIdentifier.PATH = '/v1/api/ui/company/archive/{wabaPhoneIdentifier}';
